import React, { FunctionComponent, useCallback } from 'react';
import { Button, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import styles from '../index.module.less';
import { AUDIT_STATUS } from '../dataType';

const { Title } = Typography;

interface SuccessResultProps {
  status: AUDIT_STATUS;
}

export const SuccessResult: FunctionComponent<SuccessResultProps> = props => {
  const histroy = useHistory();
  const onStartUp = useCallback(() => {
    histroy.push('/direct');
  }, []);
  return (
    props.status === AUDIT_STATUS.PASS ? 
    <div className={styles.DirectApply__SuccessResult}>
      <Title level={3}>恭喜您已完成接入的资质审核</Title>
      <Title level={4}>请联系对应的业务同学，进入开发测试阶段</Title>
      <Button
        type="primary"
        size="large"
        style={{ marginTop: 30 }}
        onClick={onStartUp}
      >进入开发测试环境</Button>
    </div>: <>{props.children}</>
  );
}